// Auto-generated build information
// Generated at: 2026-06-21T07:20:54.150Z

export const BUILD_INFO = {
  "buildTime": "2026-06-21T07:20:54.150Z",
  "version": "2.2.5",
  "name": "dlc_frontend",
  "nodeVersion": "v22.14.0",
  "environment": "production"
};

export const BUILD_TIME = "2026-06-21T07:20:54.150Z";
export const BUILD_VERSION = "2.2.5";
export const APP_NAME = "dlc_frontend";
export const NODE_VERSION = "v22.14.0";
export const BUILD_ENVIRONMENT = "production";
